export const monthNames = [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec.",
];

export const transformDate = (time) => {
    const date = new Date(time);

    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const formattedTime = `${day} ${monthNames[month]} ${year}`;
    return formattedTime;
};